var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ddd"},[_c('h1',[_vm._v("About")]),_vm._v("\n "+_vm._s(_vm.user)+"\n "+_vm._s(_vm.title)+"\n "),_c('button',{attrs:{"type":"button","value":""},on:{"click":function($event){return _vm.SetName()}}},[_vm._v("set name")])])}
var staticRenderFns = []

export { render, staticRenderFns }